export function SwipeHint() {
  return (
    <p className="card-swipe-hint" aria-hidden="true">
      ← swipe to browse →
    </p>
  );
}
